import { Box, styled, themeGet } from '@qwealth/qcore';

export const StyledAttachmentCard = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  min-width: 0;
  gap: ${themeGet('space.default')};
  background-color: ${themeGet('colors.gray.4')};
  transition: all 0.15s ease-in-out;
  padding: ${themeGet('space.default')};
  font-size: ${themeGet('fontSizes.default')};
  border-radius: ${themeGet('radii.large')};

  .file-icon-link-wrapper {
    display: flex;
    gap: ${themeGet('space.default')};
    align-items: center;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    cursor: pointer;
  }

  .link {
    color: ${themeGet('colors.dark')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }

  .delete-button {
    flex-shrink: 0;
  }

  &:hover {
    .link {
      color: ${themeGet('colors.blue')};
      text-decoration: underline;
    }
    background-color: ${themeGet('colors.gray.3')};
    transform: translateY(-1px);
  }
`;
